<template>
  <div class="p-g01-icon-ranking">
    <IconBase v-if="isTop3" :width="32" :height="37" view-box="0 0 32 37">
      <component :is="icon" />
    </IconBase>
    <component v-else :is="icon" :num="num" />
  </div>
</template>

<script lang="ts">
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconRankingFirst from "@/common/components/icons/IconRankingFirst.vue";
import IconRankingSecond from "@/common/components/icons/IconRankingSecond.vue";
import IconRankingThird from "@/common/components/icons/IconRankingThird.vue";
import IconRankingOther from "@/common/components/icons/IconRankingOther.vue";
import { Options, Vue } from 'vue-class-component';

@Options({
  props: {
	num: { type: Number, required: true }
  },
  components: {
    IconBase,
    IconRankingFirst,
    IconRankingSecond,
    IconRankingThird,
    IconRankingOther
  }
})
export default class G01IconRanking extends Vue {
  num!: number;

  get icon() {
    switch (this.num) {
      case 1:
        return "IconRankingFirst";
      case 2:
        return "IconRankingSecond";
      case 3:
        return "IconRankingThird";
      default:
        return "IconRankingOther";
    }
  }
  get isTop3() {
    return [1, 2, 3].includes(this.num);
  }
}
</script>

<style lang="scss" scoped>
.p-g01-icon-ranking {
  height: rem(37);

  @include large-sp {
    height: rem(30);
  }
}
</style>
